// extracted by mini-css-extract-plugin
export default {"text":"noStationPage__text___nfGyI"};